import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonNew as Button} from "components/buttonNew";
import FormLayout from "components/form/FormLayout";
import Input from "components/form/input";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { showSuccess } from "redux/actions/ui";

export default function QuickLinks() {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();
    const {facilityStore} = useAppSelector(store => store);

    const [link, setLink] = useState({
        clientShortName: "",
        facilityShortName: "",
      });

      useEffect(() => {
        if (facilityStore.facility) {
          setLink(prevState => ({
            ...prevState,
            facilityShortName: facilityStore.facility?.short_name,
            clientShortName: facilityStore.facility?.client?.short_name,
          }));
        }
      }, [facilityStore.facility]);

    async function writeTextToClipBoard(link: string) {
        await navigator.clipboard.writeText(link);
        dispatch(showSuccess(t("Copied link to clipboard")));
    }

    return (
        <div className="p-2">
            <p className="ui-tee-sheet-general-section-title">{t("Booking URL")}</p>
            <FormLayout>
                <FormLayout.Group>
                <Input
                    disabled={true}
                    value={window.origin + `/portal/${link?.clientShortName}/teetimes/${link?.facilityShortName}`}
                    id="portal_link"
                    trailingButtons={[
                    <Button
                        key={1}
                        onClick={() =>
                        void writeTextToClipBoard(
                            window.origin + `/portal/${link?.clientShortName}/teetimes/${link?.facilityShortName}`,
                        )
                        }
                    >
                        {" "}
                        <FontAwesomeIcon icon={faCopy} style={{ marginRight: "5px" }} /> {t("Copy")}
                    </Button>,
                    ]}
                />
                </FormLayout.Group>
            </FormLayout>
            <p className="ui-tee-sheet-general-section-title">{t("Customer URL")}</p>
            <FormLayout>
                <FormLayout.Group>
                <Input
                    disabled={true}
                    value={window.origin + "/tee-on/portal/login"}
                    id="portal_login_link"
                    trailingButtons={[
                    <Button key={1} onClick={() => void writeTextToClipBoard(window.origin + "/tee-on/portal/login")}>
                        {" "}
                        <FontAwesomeIcon icon={["far", "copy"]} style={{ marginRight: "5px" }} /> {t("Copy")}
                    </Button>,
                    ]}
                />
                </FormLayout.Group>
            </FormLayout>
        </div>
    );
}